module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r4r8n7r-1025bf587621713b5c098de551864304.svg";